/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	getRouteName,
	getUserLocation,
	getPreviousSubProduct,
	getBifrostGroup,
	getUfoName,
} from '@jira/platform__utils-router/src/common/utils/index.tsx';
import { getIsProjectAdmin } from './common/utils.tsx';
import { getIsIframe } from './common/getIsIframe.tsx';

// this special object passed to analytics allows us to get fresh route
// without requiring a full re-render on route change
export const routeAnalyticsAttributes: {} = Object.defineProperties(
	{},
	{
		routeName: { enumerable: true, get: getRouteName },
		userLocation: { enumerable: true, get: getUserLocation },
		previousSubProduct: { enumerable: true, get: getPreviousSubProduct },
		isProjectAdmin: { enumerable: true, get: getIsProjectAdmin },
		bifrostGroup: { enumerable: true, get: getBifrostGroup },
		ufoName: { enumerable: true, get: getUfoName },
		isIframe: { enumerable: true, get: getIsIframe },
	},
);
